import * as u from "three";
import { LineSegments2 as f } from "three/examples/jsm/lines/LineSegments2.js";
import { LineSegmentsGeometry as c } from "three/examples/jsm/lines/LineSegmentsGeometry.js";
import { LineMaterial as g } from "three/examples/jsm/lines/LineMaterial.js";
const a = /* @__PURE__ */ new WeakMap();
function h(e) {
  let t = a.get(e);
  return t || (t = {
    batches: /* @__PURE__ */ new Map(),
    resolution: new u.Vector2(1024, 768)
  }, a.set(e, t)), t;
}
function C(e, t) {
  return `${e}-${t}`;
}
function L(e, t, m, o, l) {
  let n = e.batches.get(t);
  if (!n) {
    const s = new c(), i = new g({
      vertexColors: !0,
      worldUnits: !1,
      linewidth: m,
      opacity: o,
      transparent: o < 1,
      resolution: e.resolution
    }), r = new f(s, i);
    r.frustumCulled = !1, l.add(r), n = { segments: r, geometry: s, material: i }, e.batches.set(t, n);
  }
  return n;
}
function M(e, t) {
  t.remove(e.segments), e.geometry.dispose(), e.material.dispose();
}
export {
  M as disposeBatch,
  h as getLineContext,
  C as getMaterialKey,
  L as getOrCreateBatch
};
//# sourceMappingURL=utils.js.map
